var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 407,
    viewBox: "0 0 432 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5025_12888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.698 49.6466L215.901 115.244L150.304 49.6466V0H96.271V71.9777L215.901 191.608L335.731 71.9777V0H281.698V49.6466Z",
    fill: "#0963EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.304 356.49L216.101 290.892L281.698 356.49V406.136H335.731V334.159L216.101 214.728L96.271 334.159V406.136H150.304V356.49Z",
    fill: "#0963EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.788 269.563L316.191 203.767L381.788 137.97H431.435V84.1362H359.457L239.827 203.767L359.457 323.397H431.435V269.563H381.788Z",
    fill: "#0963EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2121 137.97L115.809 203.966L50.2121 269.563H0.56543V323.397H72.5431L192.173 203.966L72.5431 84.1362H0.56543V137.97H50.2121Z",
    fill: "#0963EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5025_12888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430.869,
    height: 406.145,
    fill: "white",
    transform: "translate(0.56543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/_ÎÓÈ_1.efbbc5ab6ac2780547a7b6a8ea43aa8c.svg";
export { ForwardRef as ReactComponent };